<div
  #helpsWithColumn
  class="product-column-general product-helps-with"
  [style.visibility]="section?.collapseContent || rowVm.collapseContent ? 'collapse' : ''"
  [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async"
  [style.margin-right]="menu | method: 'getSectionBorderMarginSize'">
  <app-column-list-items
    [colVm]="colVm"
    [rowVm]="rowVm"
    [displayFormat]="displayFormat"
    [sectionColumnType]="colVm.columnType"
    [columnListLayoutModifierClass]="columnListLayoutModifierClass"
    [parentColumnElement]="helpsWithColumn">
  </app-column-list-items>
</div>
